import { OptionalProgramItemsEnum } from 'types/services/magnolia/enums/OptionalProgramItemsEnum';

type ProgramTarget = 'LOSE_WEIGHT' | 'GETTING_FIT';
type ProgramTargetsType = {
	[type: string]: ProgramTarget;
};

export const ProgramTargets: ProgramTargetsType = {
	LoseWeight: 'LOSE_WEIGHT',
	GettingFit: 'GETTING_FIT',
};

export const OptionaItems: { [key: string]: OptionalProgramItemsEnum } = {
	NONE: 'NONE',
	OPTIONAL_WORKOUT: 'ITOPTWORKOUT',
	OPTIONAL_RECIPE: 'ITOPTRECIPE',
};
